import { axiosRequest } from '@/util/axios-request';

// 日程类型
export var typeInfoFn = function typeInfoFn(data) {
  return axiosRequest({
    url: '/web/dashboard/getcalendartype',
    data: data
  });
};
// 日程列表
export var listFn = function listFn(data) {
  return axiosRequest({
    url: '/web/dashboard/getcalendarbyday',
    data: data
  });
};
// 新建日程
export var createFn = function createFn(data) {
  return axiosRequest({
    url: '/web/dashboard/addcalendar',
    data: data
  });
};

// 删除日程
export var delFn = function delFn(data) {
  return axiosRequest({
    url: '/web/dashboard/delcalendar',
    data: data
  });
};
// 编辑日程
export var editFn = function editFn(data) {
  return axiosRequest({
    url: '/web/dashboard/updatecalendar',
    data: data
  });
};

// 待离职列表
export var toLeaveInfoFn = function toLeaveInfoFn(data) {
  return axiosRequest({
    url: '/web/dashboard/getcalendarbymonth',
    data: data
  });
};

// 获取有日程的时间
export var hasSpotFn = function hasSpotFn(data) {
  return axiosRequest({
    url: '/web/dashboard/getcalendarbymonth',
    data: data
  });
};

// 员工出勤
export var attendanceFn = function attendanceFn(data) {
  return axiosRequest({
    url: '/web/dashboard/gettodayattendance',
    data: data
  });
};
// 司龄
export var servingFn = function servingFn(data) {
  return axiosRequest({
    url: '/web/dashboard/getcompanyage',
    data: data
  });
};
// 组织架构
export var orgFn = function orgFn(data) {
  return axiosRequest({
    url: '/web/dashboard/getfirstdepartmenthc',
    data: data
  });
};
// 人员流动
// /web/dashboard/getrecentjoinandleavecount?recent_day=7
export var flowFn = function flowFn(data) {
  return axiosRequest({
    url: '/web/dashboard/getrecentjoinandleavecount',
    data: data
  });
};
// tab角标数量
export var tabCount = function tabCount(data) {
  return axiosRequest({
    url: '/web/dashboard/getcount',
    data: data
  });
};
export var gettodayleaveoffice = function gettodayleaveoffice(data) {
  return axiosRequest({
    url: '/web/dashboard/gettodayleaveoffice',
    data: data
  });
};
/*
导出接口
/web/dashboard/exportleaveoffice?search=xxxx} data
*/
export var exportleaveoffice = function exportleaveoffice(data) {
  return axiosRequest({
    url: '/web/dashboard/exportleaveoffice',
    data: data
  });
};

// 待转正列表
export var getStaffRegular = function getStaffRegular(data) {
  return axiosRequest({
    url: '/web/dashboard/getStaffRegular',
    data: data
  });
};

// 设置转正日期、提醒日期
export var setRegularEnv = function setRegularEnv(data) {
  return axiosRequest({
    url: '/web/staff_regular/setRegularEnv',
    data: data
  });
};

// 获取转正日期、提醒日期
export var getRegularEnv = function getRegularEnv(data) {
  return axiosRequest({
    url: '/web/staff_regular/getRegularEnv',
    data: data
  });
};

// 提醒消息列表
export var noticeConfigLists = function noticeConfigLists(data) {
  return axiosRequest({
    url: '/web/staff_regular/noticeConfigLists',
    data: data
  });
};

// 添加转正提醒
export var saveNoticeConfig = function saveNoticeConfig(data) {
  return axiosRequest({
    url: '/web/staff_regular/saveNoticeConfig',
    data: data
  });
};

// 提醒消息列表
export var delNoticeConfig = function delNoticeConfig(data) {
  return axiosRequest({
    url: '/web/staff_regular/del',
    data: data
  });
};

// 修改提醒状态
export var switchNoticeConfig = function switchNoticeConfig(data) {
  return axiosRequest({
    url: '/web/staff_regular/switch',
    data: data
  });
};